











































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import ProfileImage from '@/components/Media/ProfileImage.vue';
import TenantPersonalPanel from '@/components/Admin/Panels/Profile/TenantPersonalPanel.vue';
import TenantProfilingPanel from '@/components/Admin/Panels/Profile/TenantProfilingPanel.vue';
import TenantActivityPanel from '@/components/Admin/Panels/Profile/TenantActivityPanel.vue';
import TenantApplicationPanel from '@/components/Admin/Panels/Profile/TenantApplicationPanel.vue';

@Component({
    computed: {
        ...mapGetters({
            currentTenantUser: 'UserManagement/getCarrentTenantUser',
        }),
    },
    components: {
        ProfileImage,
        TenantPersonalPanel,
        TenantProfilingPanel,
        TenantActivityPanel,
        TenantApplicationPanel,
    },
})
export default class TenantProfile extends Mixins(InputFieldMethods, DateMethods) {
    public activeTab: number = 0;

    constructor() {
        super();
    }

    get tabs(): any {
        return [
            { title: this.$t('general.personal-information', 'Personal information') },
            { title: this.$t('general.profiling', 'Profiling') },
            { title: this.$t('general.application', 'Application') },
            // { title: this.$t('general.activity', 'Activity') },
        ];
    }

    get unitLink() {
        return '#/admin/units/' + this.currentTenant.property_id;
    }

    get currentTenant() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'];
    }

    public goBack() {
        this.$router.back();
    }

    public openUnitConversation(propertyId: number) {
        this.$store.dispatch(Actions.INITIALIZE_PROPERTY_CONVERSATION, propertyId)
            .then(() => {
                this.$router.push('/admin/messages');
            });
    }

    public getFullName(user: any) {
        return user.person ? `${user.person.first_name} ${user.person.family_name}` : `${user.first_name} ${user.family_name}`;
    }

    public changeTab(tabIndex: number) {
        this.activeTab = tabIndex;
    }

    public resetPassword() {
        this.$store.dispatch(Actions.RESET_PASSWORD, {email: this.currentTenant.email});
    }

    public sendAppInvitation() {
        this.$store.dispatch(Actions.SEND_USER_INVITATION, {projectId: this.currentTenant.project_id, userId: this.currentTenant.id});
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.SET_CURRENT_TENANT_USER, null);
    }

    public beforeCreate() {
        const profileId = this.$route.params.profileId;
        if (typeof profileId !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_CURRENT_TENANT_USER, {id: profileId, mode: 'preview'});
        }
    }
}
